import Helper from "@/services/Helper"

export default class Options {
    filterParams() {
        return {
            params: {
                search: "",
                date: null,
                users: [],
                statuses: {
                    enabled: false,
                    disabled: true,
                },
            },
            enable: false,
        }
    }

    prepareQuery(q) {
        return  Helper.clone(q)
    }
}
